import { usePatientStats } from "../hooks/patients.hooks";

const PatientStatCommand = ({ id }: { id: string | number | undefined }) => {
    const { data: stats } = usePatientStats(id)
    
    if (stats === null || stats === undefined) {
        return <>0</>
    }
    return <>{ stats.commandsCount ?? 0 }</>
}

export default PatientStatCommand;